import { supabase } from '@/integrations/supabase/client';

export interface FreePlanLimits {
  /** Mensajes de chat para opositores free */
  chat_messages: number;
  opositor_tests: number;
  opositor_cases: number;
  opositor_flashcards: number;
  /** Materiales (presentación / resumen / infografía) para opositores free */
  opositor_materials: number;
  /** Mensajes de chat para funcionarios free */
  funcionario_chat_messages: number;
  /** Documentos generados por día (modo funcionarios) */
  funcionario_documents: number;
}

export const DEFAULT_FREE_LIMITS: FreePlanLimits = {
  chat_messages: 3,
  opositor_tests: 10,
  opositor_cases: 2,
  opositor_flashcards: 20,
  opositor_materials: 2,
  funcionario_chat_messages: 10,
  funcionario_documents: 1,
};

let cached: { value: FreePlanLimits; timestamp: number } | null = null;
const CACHE_TTL = 60_000;

export function invalidateFreePlanLimitsCache() {
  cached = null;
}

export async function getFreePlanLimits(): Promise<FreePlanLimits> {
  if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
    return cached.value;
  }
  try {
    const { data, error } = await (supabase.rpc as any)('get_free_plan_limits');
    if (error || !data) {
      return { ...DEFAULT_FREE_LIMITS };
    }
    const value: FreePlanLimits = {
      chat_messages: Number(data.chat_messages ?? DEFAULT_FREE_LIMITS.chat_messages),
      opositor_tests: Number(data.opositor_tests ?? DEFAULT_FREE_LIMITS.opositor_tests),
      opositor_cases: Number(data.opositor_cases ?? DEFAULT_FREE_LIMITS.opositor_cases),
      opositor_flashcards: Number(data.opositor_flashcards ?? DEFAULT_FREE_LIMITS.opositor_flashcards),
      opositor_materials: Number(data.opositor_materials ?? DEFAULT_FREE_LIMITS.opositor_materials),
      funcionario_chat_messages: Number(
        data.funcionario_chat_messages ?? DEFAULT_FREE_LIMITS.funcionario_chat_messages,
      ),
      funcionario_documents: Number(
        data.funcionario_documents ?? DEFAULT_FREE_LIMITS.funcionario_documents,
      ),
    };
    cached = { value, timestamp: Date.now() };
    return value;
  } catch {
    return { ...DEFAULT_FREE_LIMITS };
  }
}

export async function updateFreePlanLimits(limits: FreePlanLimits): Promise<FreePlanLimits> {
  const { data, error } = await (supabase.rpc as any)('update_free_plan_limits', {
    p_chat_messages: limits.chat_messages,
    p_opositor_tests: limits.opositor_tests,
    p_opositor_cases: limits.opositor_cases,
    p_opositor_flashcards: limits.opositor_flashcards,
    p_opositor_materials: limits.opositor_materials,
    p_funcionario_chat_messages: limits.funcionario_chat_messages,
    p_funcionario_documents: limits.funcionario_documents,
  });
  if (error) throw error;
  invalidateFreePlanLimitsCache();
  return data as FreePlanLimits;
}
